import React, { useState } from 'react';
import { SiteSection } from '../../components/site';
import type { ProductSubpageConfig } from '../product-subpage/types';

export const SolutionHospitalityCapabilities: React.FC<{
  capabilities: ProductSubpageConfig['capabilities'];
}> = ({ capabilities }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <SiteSection id="capabilities" className="hosp-capabilities">
      <header className="hosp-capabilities__header">
        <p className="io-site-section__eyebrow">{capabilities.eyebrow}</p>
        <h2 className="io-site-section__title">{capabilities.title}</h2>
        {capabilities.subtitle ? (
          <p className="io-site-section__subtitle">{capabilities.subtitle}</p>
        ) : null}
      </header>

      <div className="hosp-capabilities__accordion" role="tablist" aria-label={capabilities.title}>
        {capabilities.items.map((item, index) => {
          const isActive = index === activeIndex;
          const num = String(index + 1).padStart(2, '0');
          const tabId = `hosp-cap-tab-${index}`;
          const panelId = `hosp-cap-panel-${index}`;

          return (
            <button
              key={item.title}
              id={tabId}
              type="button"
              role="tab"
              aria-selected={isActive}
              aria-controls={panelId}
              className={`hosp-capabilities__item${isActive ? ' is-active' : ''}`}
              onClick={() => setActiveIndex(index)}
              onMouseEnter={(e) => {
                setActiveIndex(index);
                e.currentTarget.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
              }}
            >
              <div className="hosp-capabilities__item-inner">
                <span className="hosp-capabilities__num" aria-hidden>
                  {num}
                </span>
                <span
                  id={panelId}
                  role="tabpanel"
                  aria-labelledby={tabId}
                  className="hosp-capabilities__content"
                >
                  <span className="hosp-capabilities__title">{item.title}</span>
                  {isActive ? (
                    <>
                      {item.description ? (
                        <span className="hosp-capabilities__desc">{item.description}</span>
                      ) : null}
                      {item.bullets && item.bullets.length > 0 ? (
                        <ul className="hosp-capabilities__bullets">
                          {item.bullets.map((bullet) => (
                            <li key={bullet}>{bullet}</li>
                          ))}
                        </ul>
                      ) : null}
                    </>
                  ) : null}
                </span>
              </div>
            </button>
          );
        })}
      </div>
    </SiteSection>
  );
};
